import { useEffect, useState } from "react";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// hooks
import { usePostulacion } from "./usePostulacion";
import { useNavigate } from "react-router";
import { openNotification } from "../utils/Notifactions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers/index";
import DocumentosService from "../api/Documentos/api-documentos";
import { guardarDatosPostulacion } from "../redux/actions/participantesAction";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";

export const useDocumentosAdministrativos = () => {
  // hooks
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  const [documentos, setDocumentos] = useState([]);

  const [loading, setLoading] = useState(false);
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );
  const { cargarPostulacionTipoParticipante } = usePostulacion();
  const _tipoParticipante = localStorage.getItem(
    "tipo_participante_postulacion"
  );
  // const { convocatoria, setDocumentos, getConvocatoria, descargarArchivo } = UseVerConvocatorias();

  //   route
  const navigate = useNavigate();
  //   redux variables

  useEffect(() => {
    getDocumentos()
  }, []);

  const getDocumentos = async () => {
    //console.log('Convocatoria: ', localStorage.getItem('idConvocatoriaPostulacion'))

    const { data } = await apiConvocatorias.obtenerDocumentosAdministrativos(decrypt(localStorage.getItem('idConvocatoriaPostulacion')))


    /* const { data } = await apiParticipantes.consultarDocumentosAdministrativos(
      decrypt(localStorage.getItem("id_postulacion"))
    ); */

    if (data.documentos_administrativos) {
      let resp = data.documentos_administrativos.filter((x) => x !== null).map(
        (doc: any, index: number) => {
          return {
            id: doc.id,
            idconvocatoria: doc.idconvocatoria,
            descripcion: doc.descripcion,
            obligatorio: doc.obligatorio,
            subsanable: doc.subsanable,
            tipo_documento_id: doc.tipo_documento_id,
            tipo_persona: doc.tipo_persona,
            url_documento: doc.url_documento,
            url_participante: doc.url_participante,
          }
        }
      );

      let docs = resp.filter(
        (doc) => doc.tipo_persona === Number(_tipoParticipante)
      );

      return setDocumentos(docs);
    }
  };

  const guardarArchivosAdministrativos = async (
    datos: any,
    e: any,
    index: number
  ) => {
    if (e.target.files.length > 0) {
      let documento = e.target.files[0];
      if (documento.size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (documento.type !== "application/pdf") {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", documento);
      let data = await DocumentosService.guardarArchivo(formData);

      let nuevosdocumentos: any = documentos.map(
        (doc: any, indexdoc: number) => {
          if (index === indexdoc) {

            return {
              ...doc,
              url_participante: data.data,
            };
          }
          return {
            ...doc,
          };
        }
      );
      console.log(nuevosdocumentos);
      document
        .getElementsByClassName("cards-documentos")
      [index].classList.remove("border-error-cards-documentos");
      localStorage.setItem('documentos', JSON.stringify(nuevosdocumentos));
      return setDocumentos(nuevosdocumentos);
    }
  };

  const eliminarArchivo = async (e: any, index: number, idDocAdmin: number) => {
    await DocumentosService.eliminarArchivo(documentos[index].url_participante);
    let nuevosdocumentos: any = documentos.map((doc: any, indexdoc: number) => {
      if (idDocAdmin === doc.id) {
        return {
          ...doc,
          url_participante: "",
        };
      }
      return {
        ...doc,
      };
    });


    return setDocumentos(nuevosdocumentos);
  };

  const consultarArchivos = async (guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    // var error = false;
    documentos.map((doc: any, indexdoc: number) => {
      // if (Number(_tipoParticipante) - 1 === doc.tipo_persona) {
      //   if (doc.url_participante) {
      //     // if (doc.url_participante === "") {
      //     //   document.getElementsByClassName("cards-documentos")[
      //     //     indexdoc
      //     //   ].className += " border-error-cards-documentos";
      //     //   error = true;
      //     // }
      //     return {
      //       ...doc,
      //     };
      //   }
      //   error = true;
      //   document.getElementsByClassName("cards-documentos")[
      //     indexdoc
      //   ].className += " border-error-cards-documentos";
      return {
        ...doc,
      };
      // }
    });

    // if (error) {
    //   return;
    // }

    // let nuevosdocumentos = postulacion.documentos_administrativos.map((doc: any) => participante.participantes.tipo_participante - 1 === doc.tipo_persona);
    // console.log(nuevosdocumentos);

    try {
      setLoading(true);
      await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
        decrypt(localStorage.getItem("id_postulacion")),
        documentos
      );

      dispatch(
        guardarDatosPostulacion({
          ...datos_postulacion,
          documentos_administrativos: documentos,
        })
      );
      setLoading(false);
      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        return navigate("/usuario/Documentostecnicos");
      }
    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };

  return {
    guardarArchivosAdministrativos,
    cargarPostulacionTipoParticipante,
    documentos,
    setDocumentos,
    eliminarArchivo,
    consultarArchivos,
    loading
  };
};
